import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { TranslationService } from 'src/app/service/translation.service';

/**
 * Child Component which is a modal for adding value(s) or a setting description
 */
@Component({
    selector: 'app-add-value-form-settings',
    templateUrl: './add-value-form.component.html',
    styleUrls: ['./add-value-form.component.scss'],
    standalone: true,
    providers: [NgbModalConfig, NgbModal, TranslationService],
    imports: [TranslateModule, CommonModule, ReactiveFormsModule]
})
export class AddValueFormComponent implements OnInit {

  @Input() parameter?: string
  @Input() dico?: boolean

  /**variable for string setting_value */
  @Input() onlyone?: boolean


  @Output() newValuesL = new EventEmitter<string[]>()
  @Output() newValuesM = new EventEmitter<string[][]>()
  formKey: UntypedFormArray
  formArray: UntypedFormArray
  @Input() ltocompare!: string[];
  @Input() description?: boolean

  constructor(config: NgbModalConfig, private readonly modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
    this.formKey = new UntypedFormArray([])
    this.formArray = new UntypedFormArray([])

  }

  /**
   * Init different form according to the type of setting_value detected
   */
  ngOnInit(): void {
    if (!this.dico && this.ltocompare) {
      this.formArray.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.notExistValidator(this.ltocompare), Backend.SETTINGS.noWhitespaceValidator()]))
    }
    if (!this.dico && !this.ltocompare) {
      this.formArray.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.noWhitespaceValidator()]))
    }
    if (this.dico && this.ltocompare) {
      this.formArray.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.noWhitespaceValidator()]))
      this.formKey.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.notExistValidator(this.ltocompare), Backend.SETTINGS.noWhitespaceValidator()]))
    }
  }

  getControl(i: number) {
    return this.formArray.controls[i] as UntypedFormControl
  }
  getKey(i: number) {
    return this.formKey.controls[i] as UntypedFormControl
  }

  getLengtMapForm() {
    let tab: any[] = []
    let valuesl = this.formArray.controls.length
    let keyl = this.formKey.controls.length
    if (valuesl === keyl) {
      this.formArray.controls.forEach(el => tab.push(this.formArray.controls.indexOf(el)))
    }
    return tab
  }

  open({ content }: { content: any }) {
    this.modalService.open(content, { centered: true })
  }

  /**
   * Add new FormControl if it's for adding new values in a list or in a map
   */
  addnewForm() {
    if (!this.dico && this.ltocompare) {
      this.formArray.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.notExistValidator(this.ltocompare), Backend.SETTINGS.noWhitespaceValidator],))
    }
    if (!this.dico && !this.ltocompare) {
      this.formArray.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.noWhitespaceValidator]))
    }
    if (this.dico && this.formKey) {
      this.formKey.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.notExistValidator(this.ltocompare), Backend.SETTINGS.noWhitespaceValidator]))
      this.formArray.push(new UntypedFormControl('', [Validators.required, Backend.SETTINGS.noWhitespaceValidator]))
    }
  }

  /**
   * Detect for all forms value(s) added are valid
   * 
   * @returns boolean
   */
  oneInvalid() {
    if (this.dico) {
      return this.getLengtMapForm().some(i => this.formKey.controls[i].invalid || this.formArray.controls[i].invalid);
    } else {
      return this.formArray.controls.some(el => el.invalid);
    }
  }

  /**
   * Emit forms values entered by user
   */
  getAllValue() {
    let ltoemit = []
    if (!this.dico && this.ltocompare) {
      this.formArray.value.forEach((el: string) => {
        if (!this.ltocompare.includes(el)) {
          ltoemit.push(el)
        }
      });
    }
    if (!this.dico && !this.ltocompare) {
      ltoemit.push(this.formArray.value[0])
    }
    if (this.dico && this.ltocompare) {
      for (let i = 0; i < this.formKey.value.length; i++) {
        if (!this.ltocompare.includes(this.formKey.value[i])) {
          ltoemit.push([this.formKey.value[i], this.formArray.value[i]])
        }
      }
    }
    if (this.dico) {
      this.newValuesM.emit(ltoemit)
    }
    else {
      this.newValuesL.emit(ltoemit)
    }
  }
}
